// extracted by mini-css-extract-plugin
export default {"h1":"style_h1__EGi3y"};